import { render, staticRenderFns } from "./post_list_simple.vue?vue&type=template&id=7955462e&scoped=true&"
import script from "./post_list_simple.vue?vue&type=script&lang=js&"
export * from "./post_list_simple.vue?vue&type=script&lang=js&"
import style0 from "./post_list_simple.vue?vue&type=style&index=0&id=7955462e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7955462e",
  null
  
)

export default component.exports